export const environment = {
  production: true,
  apiUrl:'https://localhost:8443/rest',
  previewUrl: 'https://your-prod-domain.com/preview',
  defaultLocale:"en-ZA",
  chatAipUrl:'/api'
};
